import { Components, Theme } from '@mui/material/styles';

export const headerTheme: Components<Theme>['MuiAppBar'] = {
  // styleOverrides: {},
  // variants: [],
};
